import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { generateQuoteDocx } from "./generateQuoteDocx";
import ComboBox from "../../component/ComboBox";
import DataAdapter from "../../adapter/DataAdapter";
import Page from "../../../components/Page";

export default function QuoteSubsystem() {
  const [items, setItems] = useState([]);
  const [newItem, setNewItem] = useState({ description: "", qty: 1, price: 0 });
  const [modal, setModal] = useState(false);
  const [previewModal, setPreviewModal] = useState(false);
  const [projectId, setProjectId] = useState(-1);
  const [project, setProject] = useState([]);
  const [company, setCompany] = useState([]);
  const [client, setClient] = useState([]);

  const toggle = () => setModal(!modal);
  const togglePreview = () => setPreviewModal(!previewModal);

  useEffect(()=>{
    if(projectId!=-1){
        (new DataAdapter(`CALL Get_Project(${projectId});`)).getRecords().then(data=>{setProject(data[0]);
            setCompany(data[0].prj_department.split(';'));
            setClient(data[0].client_id.split(';'));
        });

    }
  },[projectId])
  const handleAddItem = () => {
    setItems([...items, newItem]);
    setNewItem({ description: "", qty: 1, price: 0 });
    toggle();
  };

  const handleChange = (e) => {
    setNewItem({ ...newItem, [e.target.name]: e.target.value });
  };

  const updateItem = (index, field, value) => {
    const list = [...items];
    list[index][field] = value;
    setItems(list);
  };

  const subtotal = items.reduce((sum, item) => sum + Number(item.qty) * Number(item.price), 0);
  const hst = subtotal * 0.13;
  const total = subtotal + hst;


  return (
    <Page>
        <Container className="mt-4">
            <Row>
                <Col md={8}>
                <Card>
                    <CardHeader>Create Quote</CardHeader>
                    <CardBody> 
                    {/* Project Selection */}
                    <FormGroup>
                        <Label>Project</Label>
                        <ComboBox title="Projects" onChange={async (e)=>{setProjectId(e.target.value);}} table="rb_projects" filterField="prj_status" filterValue={"9"} valueField="prj_id" displayField="prj_id,prj_address,prj_title"  orderby="prj_id" defaultValue={projectId} />
                    </FormGroup>

                    <Button color="primary" onClick={toggle}>Add Item</Button>

                    <Table className="mt-3" bordered>
                        <thead>
                        <tr>
                            <th>Description</th>
                            <th width="120">Qty</th>
                            <th width="150">Unit Price</th>
                            <th width="150">Total</th>
                        </tr>
                        </thead>
                        <tbody>
                        {items.map((item, index) => (
                            <tr key={index}>
                            <td>
                                <Input
                                type="textarea"
                                rows={2}
                                value={item.description}
                                onChange={(e) => updateItem(index, "description", e.target.value)}
                                />
                            </td>
                            <td>
                                <Input
                                type="number"
                                value={item.qty}
                                onChange={(e) => updateItem(index, "qty", e.target.value)}
                                />
                            </td>
                            <td>
                                <Input
                                type="number"
                                value={item.price}
                                onChange={(e) => updateItem(index, "price", e.target.value)}
                                />
                            </td>
                            <td>${(item.qty * item.price).toFixed(2)}</td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                    </CardBody>
                </Card>
                </Col>

                {/* Summary */}
                <Col md={4}>
                <Card>
                    <CardHeader>Summary</CardHeader>
                    <CardBody>
                    <div className="d-flex justify-content-between">
                        <span>Subtotal:</span>
                        <strong>${subtotal.toFixed(2)}</strong>
                    </div>

                    <div className="d-flex justify-content-between mt-2">
                        <span>HST (13%):</span>
                        <strong>${hst.toFixed(2)}</strong>
                    </div>

                    <div className="d-flex justify-content-between mt-3 border-top pt-2">
                        <span>Total:</span>
                        <strong>${total.toFixed(2)}</strong>
                    </div>

                    <Button color="info" block className="mt-3" onClick={togglePreview}>Preview</Button>
                    <Button
                            color="primary" block className="mt-3"
                            onClick={() =>
                                generateQuoteDocx({
                                company:{id: company[0],name:company[1], address:company[6], phone:company[7], email:company[2]},
                                client:{name:client[0], address:client[2], phone:client[1], email:client[3]},
                                project: project,
                                items: items,
                                subtotal,
                                hst,
                                total,
                                logoBase64: company[3],
                                })
                            }
                            >
                            Export DOCX
                        </Button>
                    <Button color="success" block className="mt-3">Save Quote</Button>
                    </CardBody>
                </Card>
                </Col>
            </Row>

            {/* Add Item Modal */}
            <Modal isOpen={modal} toggle={toggle} centered>
                <ModalHeader toggle={toggle}>Add Quote Item</ModalHeader>
                <ModalBody>
                <Form>
                    <FormGroup>
                    <Label>Description (supports multiline)</Label>
                    <Input
                        type="textarea"
                        name="description"
                        rows={5}
                        value={newItem.description}
                        onChange={handleChange}
                    />
                    </FormGroup>

                    <Row>
                    <Col>
                        <FormGroup>
                        <Label>Qty</Label>
                        <Input type="number" name="qty" value={newItem.qty} onChange={handleChange} />
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                        <Label>Unit Price</Label>
                        <Input type="number" name="price" value={newItem.price} onChange={handleChange} />
                        </FormGroup>
                    </Col>
                    </Row>
                </Form>
                </ModalBody>
                <ModalFooter>
                <Button color="primary" onClick={handleAddItem}>Add Item</Button>
                <Button color="secondary" onClick={toggle}>Cancel</Button>
                </ModalFooter>
            </Modal>

            {/* Preview Modal */}
            <Modal isOpen={previewModal} toggle={togglePreview} size="lg">
                <ModalHeader toggle={togglePreview}>Quote Preview</ModalHeader>
                <ModalBody>
                <h5>Project: {projectId || "Not selected"}</h5>
                <Table bordered className="mt-3">
                    <thead>
                    <tr>
                        <th>Description</th>
                        <th>Qty</th>
                        <th>Unit Price</th>
                        <th>Total</th>
                    </tr>
                    </thead>
                    <tbody>
                    {items.map((item, i) => (
                        <tr key={i}>
                        <td style={{ whiteSpace: "pre-wrap" }}>{item.description}</td>
                        <td>{item.qty}</td>
                        <td>${item.price}</td>
                        <td>${(item.qty * item.price).toFixed(2)}</td>
                        </tr>
                    ))}
                    </tbody>
                </Table>

                <h5 className="mt-3">Subtotal: ${subtotal.toFixed(2)}</h5>
                <h5>HST (13%): ${hst.toFixed(2)}</h5>
                <h4>Total: ${total.toFixed(2)}</h4>
                </ModalBody>
            </Modal>
        </Container>
    </Page>
  );
}